export default __webpack_public_path__ + "static/media/logopb-white.5fa3b226.svg";